/* eslint-disable import/order */
import React from 'react';
import type PlanTimelineType from '@jira/spa-apps__advanced-roadmaps-plan-timeline/src/ExportedComponent.tsx';
import { planTimelineEntryPoint } from '@jira/spa-apps__advanced-roadmaps-plan-timeline/src/planTimelineEntryPoint.entrypoint.tsx';
import {
	advancedRoadmapsPlanPageInitialChecksResource,
	advancedRoadmapsReduxStoreStateResource,
} from '@jira/router-resources__advanced-roadmaps-plan/src/advancedRoadmapsPlanPageInitialChecksResource.tsx';
import { getPlansBacklogResource } from '@jira/router-resources__advanced-roadmaps-plan/src/plansBacklogResource.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { createLayout } from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { arjTimelineEmbedRoute } from '@jira/router-routes__advanced-roadmaps-embed-routes/src/arjTimelineEmbedRoute.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const planTimelineEmbedRouteEntry = createChromelessEntryPoint({
	main: planTimelineEntryPoint,
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyPlanTimelineEmbed = lazyForPaint<typeof PlanTimelineType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-plan-timeline-embed", jiraSpaEntry: "async-plan-timeline-embed" */ '@jira/spa-apps__advanced-roadmaps-plan-timeline/src/ExportedComponent.tsx'
			),
		),
	{ ssr: false },
);

const PlanTimelineEmbedPage = () => (
	<LazyPage Page={LazyPlanTimelineEmbed} pageId="plan-timeline-embed" shouldShowSpinner />
);

export const arjTimelineEmbedRouteEntry: Route = createEntry(arjTimelineEmbedRoute, () => ({
	group: 'software',
	// eslint-disable-next-line no-restricted-syntax
	component: PlanTimelineEmbedPage,
	entryPoint: () => planTimelineEmbedRouteEntry,

	layout: createLayout({
		isChromeless: true,
	}),

	resources: [
		advancedRoadmapsPlanPageInitialChecksResource,
		...getPlansBacklogResource(),
		advancedRoadmapsReduxStoreStateResource,
		...jiraSpaResources(),
	],

	preloadOptions: {
		earlyChunks: ['advanced-roadmaps-early-entry'],
	},

	forPaint: [LazyPlanTimelineEmbed],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
